import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
//components
import FormCreator from 'components/FormCreator';
import { fieldsGroupType, fieldType, validationTypes } from 'components/FormCreator/types';
import UserEditCard from './UserEditCard';
//reducers
import {
	getAvailableLanguages,
	getLangAsync,
	selectLanguage,
	selectTranslations,
	toggleLang,
} from 'state/reducers/translation.reducers';
import { fetchAvailableLanguages } from 'services/translation.services';

export default function EditLanguage({ handleCancelEdit }) {
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const [language, setLanguage] = useState(useAppSelector(selectLanguage));
	const prefixFields = 'page.settings.my_profile.user_language.';
	const languages = useAppSelector(getAvailableLanguages);
	const [translatedLanguages, setTranslatedLanguages] = useState([]);
	const handleSaveClick = () => {
		const formData = new FormData();
		formData.append('preferredLanguage', String(language));
		/*dispatch(
      changeUserData(
        { language },
        formData,
        FormInputsTypes.LANGUAGE,
        API_UPDATE_CONTACT_LANGUAGE
      )
    );*/
		dispatch(toggleLang(language));
		dispatch(getLangAsync(language));
		handleCancelEdit();
	};

	useEffect(() => {
		dispatch(fetchAvailableLanguages());
	}, []);

	useEffect(() => {
		if (languages?.length > 0) {
			const languagesKeys = languages.map((language: any) => {
				return {
					...language,
					label: t(`page.settings.my_profile.user_language.language.${_.snakeCase(language.value)}.text`),
				};
			});
			setTranslatedLanguages(languagesKeys);
		}
	}, [languages]);

	return (
		<UserEditCard
			handleSaveClick={handleSaveClick}
			handleCancelEdit={handleCancelEdit}
			title={t(prefixFields + 'title')}
			cancelButtonText={t(prefixFields + 'cancel_button.text')}
			saveButtonText={t(prefixFields + 'save_button.text')}
		>
			<FormCreator
				name="contactLanguage"
				handleChange={(e: any) => setLanguage(e.target.value)}
				fieldsGroups={[
					{
						type: fieldsGroupType.col,
						fields: [
							{
								type: fieldType.selectBox,
								validation: [validationTypes.requierd],
								props: {
									required: true,
									name: 'languageId',
									label: t(`${prefixFields}language_pick.text`),
									value: language,
									options: _.values(translatedLanguages),
								},
							},
						],
					},
				]}
			/>
		</UserEditCard>
	);
}
